import {action, observable} from 'mobx'
import {observer} from 'mobx-react'
import styled from 'styled-components'
import React, {Component} from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Row from '../../components/Row'
import request from '../../utils/request'
import PasswordCheck from "../../components/PasswordCheck";
import Text from "../../components/Text"

const Box = styled.div`
  margin: 1.5rem;
`

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 300;
  font-size: 1.1rem;
  margin-bottom: 1rem;
`
@observer
export class ExternalSignUp extends Component {
  @observable error = false
  @observable loading = false

  @observable
  fields = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  }

  @action
  setField = event => {
    this.error = false
    this.fields[event.target.name] = event.target.value
  }
  @action
  setLoading = () => {
    this.loading = true
    this.error = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  submit = async event => {
    const { onNext } = this.props
    event.preventDefault()
    this.setLoading()
    const { confirmPassword, ...fields } = this.fields

    if (fields.password !== confirmPassword) {
      this.setError()
      return
    }

    const res = await request('/api/auth/signUp', fields)

    if (res.success) {
      onNext()
    } else {
      this.setError()
    }
  }


  render() {
    const { onCancel } = this.props

    return (
      <form onSubmit={this.submit}>
        <Card>
          <Box>
            <Labels>
              <Text str="titles.signUp" />
            </Labels>
          </Box>
          <Card.Divider />
          {this.error && <Card.ErrorMessage />}
          <Card.Pad>
            <Row>
              <Row.Cell>
                <Input
                  disabled={this.loading}
                  label="titles.firstName"
                  name="firstName"
                  value={this.fields.firstName}
                  onChange={this.setField}
                />
              </Row.Cell>
              <Row.Cell>
                <Input
                  disabled={this.loading}
                  label="titles.lastName"
                  name="lastName"
                  value={this.fields.lastName}
                  onChange={this.setField}
                />
              </Row.Cell>
            </Row>
          </Card.Pad>
          <Card.Divider />
          <Card.Pad>
            <Input
              disabled={this.loading}
              label="titles.email"
              name="email"
              value={this.fields.email}
              onChange={this.setField}
            />
            <Input
              disabled={this.loading}
              label="titles.password"
              name="password"
              type="password"
              value={this.fields.password}
              onChange={this.setField}
            />
            <PasswordCheck password={this.fields.password} />
            <Input
              disabled={this.loading}
              label="titles.confirmPassword"
              name="confirmPassword"
              type="password"
              value={this.fields.confirmPassword}
              onChange={this.setField}
            />
          </Card.Pad>
          <Card.Divider />
          <Card.Pad>
            <Row>
              <Row.Cell>
                <Button
                  color="gray"
                  str="titles.cancel"
                  onClick={onCancel}
                />
              </Row.Cell>
              <Row.Cell>
                <Button
                  color="blue"
                  disabled={this.loading}
                  str="titles.submit"
                  type="submit"
                />
              </Row.Cell>
            </Row>
          </Card.Pad>
        </Card>
      </form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/SignUp/ExternalSignup.js